var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "wrap" } }, [
      _c("div", { attrs: { id: "topbar" } }, [
        _c("button", { staticClass: "addfile primary" }, [
          _vm._v("+ 添加文件")
        ]),
        _c("button", { staticClass: "upall primary" }, [_vm._v("全部上传")]),
        _c("button", { staticClass: "removeall" }, [_vm._v("清空列表")])
      ]),
      _c("ul", { attrs: { id: "file_list" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }